import ProposalReviewer from "../../proposal-reviewer";

export type ProposalReviewerAPIRequestPayload = {
  userId?: string;
  entityId?: string;
  canEdit?: boolean;
  dateApproved?: string;
  customMessage?: string;
};
export default class ProposalReviewerCommand {
  userId?: string;
  entityId?: string;
  canEdit?: boolean;
  dateApproved?: string;
  customMessage?: string;

  constructor(reviewer: ProposalReviewer) {
    if (!reviewer?.entityMember) {
      throw new Error("Reviewer must indicate entity fee schedule is being created for.");
    }
    this.userId = reviewer?.entityMember?.userId.value;
    this.entityId = reviewer?.entityMember?.legalEntityId.value;
    this.canEdit = reviewer?.canEdit;
    this.dateApproved = reviewer?.dateApproved?.toISOString();
    this.customMessage = reviewer?.customMessage;
  }

  public get payload(): ProposalReviewerAPIRequestPayload {
    return {
      userId: this.userId,
      entityId: this.entityId,
      canEdit: this.canEdit,
      dateApproved: this.dateApproved,
      customMessage: this.customMessage
    };
  }
}
